import { Button } from 'core-components/library/button'
import {
  AbsolutePopup,
  PopPaper,
  TPopupHorizontal,
  TPopupVertical,
} from 'core-components/library/popup'
import { TOOLBAR_BUTTONS } from 'core-components/library/richTextEditor/interface/IToolbar'

import { TOOLBAR_TITLES } from '../../constants'

import { TableInsertPopup } from './TableInsertPopup'

interface IProps {
  disabled: boolean
}

export const TableButton = ({ disabled }: IProps) => {
  return (
    <AbsolutePopup
      horizontalDirection={TPopupHorizontal.Center}
      horizontalStartPosition={TPopupHorizontal.Right}
      verticalStartPosition={TPopupVertical.Bottom}
      popupContent={(popupContent) => (
        <PopPaper>
          <TableInsertPopup close={popupContent.action.close} />
        </PopPaper>
      )}
      visibilityCallback={(newVisible) => {
        if (disabled) {
          return false
        }
        return newVisible
      }}
    >
      <Button
        disabled={disabled}
        title={TOOLBAR_TITLES[TOOLBAR_BUTTONS.Table]}
        color={'grey'}
        variant={'text'}
        iconButton={'kbase kbase-editor-add-table'}
      />
    </AbsolutePopup>
  )
}
